import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { ITooltipsDto } from "../../../features/globals/interface/dto/tooltips.dto";
import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { TooltipPageId } from "../enums/tooltip.enum";
import { getTooltips } from "../services/tooltips.api";

const {
    actions: tooltipsActions,
    reducer: tooltipsReducer,
    epic: tooltipsEpic,
} = createIGSERedux<Array<ITooltipsDto>>({
    actionNames: {
        init: "TOOLTIPS_INIT",
        get: "TOOLTIPS_GET",
        success: "TOOLTIPS_SUCCESS",
        error: "TOOLTIPS_ERROR",
    },
    fetcher: () =>
        getTooltips(TooltipPageId.UserPreferences, selectAuthTokens()),
    selector: (state: IRootState) => state.userPreferences.tooltips,
});

export { tooltipsActions, tooltipsReducer, tooltipsEpic };
